// @flow

import React from 'react';

import Link from '@zapier/common-components/src/components/Link';
import MessageBar from '@zapier/common-components/src/components/MessageBar';

type Props = {
  additionalContext?: string,
  email: string,
  errorMessages: Array<string>,
  hasConfirmedEmail: boolean,
  hasSentConfirmationEmail?: boolean,
  hasSentEmailChangeRequest?: boolean,
  onConfirm: number => void,
  profileId: number,
};

const Errors = ({ errorMessages }) => (
  <MessageBar.MessageList>
    {errorMessages.map((error, i) => (
      <li key={i}>{error}</li>
    ))}
  </MessageBar.MessageList>
);

const ConfirmEmail = (props: Props) => {
  const onConfirm = () => props.onConfirm(props.profileId);

  if (props.hasSentConfirmationEmail === true) {
    return (
      <MessageBar title="" type="warning" typography="body">
        Confirmation email sent, check your email to confirm.
      </MessageBar>
    );
  }

  if (props.hasSentConfirmationEmail === false) {
    return (
      <MessageBar type="error" typography="body">
        There was an error sending the email, please{' '}
        <Link onClick={onConfirm} underline="always">
          try again
        </Link>
        :<Errors errorMessages={props.errorMessages} />
      </MessageBar>
    );
  }

  if (props.hasSentEmailChangeRequest === true) {
    return (
      <MessageBar title="" type="warning" typography="body">
        Check your email to confirm your change request.
      </MessageBar>
    );
  }

  if (props.hasSentEmailChangeRequest === false) {
    return (
      <MessageBar type="error" typography="body">
        An error occurred while attempting to change your email address:
        <Errors errorMessages={props.errorMessages} />
      </MessageBar>
    );
  }

  if (props.hasConfirmedEmail === true) {
    return (
      <MessageBar type="success" typography="body">
        Your current email address ({props.email}) is confirmed.
      </MessageBar>
    );
  }

  return (
    <MessageBar title="" type="warning" typography="body">
      You need to{' '}
      <Link id="confirm-link" onClick={onConfirm} underline="always">
        confirm your current email address ({props.email})
      </Link>
      {props.additionalContext ? ' ' + props.additionalContext : '.'}
    </MessageBar>
  );
};

export default ConfirmEmail;
